<template>
  <div v-if="internalValue!==undefined" class="checkbox-input" @click="() => {internalValue = !internalValue}">
    <input v-model="internalValue" type="checkbox">
    <label class="checkbox-label" :class="{active: internalValue}">{{ $t(text) }}</label>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'config',
    event: 'change-input',
  },
  props: {
    config: Boolean,
    text: String,
  },
  computed: {
    internalValue: {
      get() {
        return this.config
      },
      set(value) {
        this.$emit('change-input', value)
      },
    },
  },
}
</script>

<style lang="stylus" scoped>
.checkbox-input
  display: flex
  align-items: center
  cursor: pointer

  &:hover
    .checkbox-label
      &:not(.active)
        color: black

  .checkbox-label
    m-font-size(14, 22)
    color: $grey-dark
    cursor: pointer

    &.active
      color: $corporate_color

  input
    cursor: pointer
</style>
